import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import './App.css';
import CookieConsent from "react-cookie-consent";
import GA4React from "ga-4-react";

import { createTheme, ThemeProvider } from '@mui/material/styles';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box';

import MenuPrincipal from './components/MenuPrincipal';
import QuandConsulter from './components/QuandConsulter';
import Marjolaine from './components/Majolaine';
import Coordonnees from './components/Coordonnees';
import Tarifs from './components/Tarifs';
import CestQuoi from './components/CestQuoi';

import Carte from './components/Carte';
import Pied from './components/Pied';

const red = '#EE6C87';
const blue = '#82D2EE';
const yellow = '#F7CE74';
const black = '#283054';
const green = '#06D6A0';
const white = '#FDF5FE';

const theme = createTheme({
  palette: {
    primary: {
      main: black,
    },
    secondary: {
      main: green,
    },
  },
  typography: {
    fontFamily: [
      'Josefin Sans',
      'sans-serif',
    ].join(','),
    fontWeightRegular: 300,
    fontWeightBold: 600,
    body1: {
      fontSize: '1.35em',
      letterSpacing: '0em',
      flexGrow:1,
      display: 'flex',
    },
    h1: {
      fontSize: '2em',
      fontWeight: 600,
      fontKerning: 'normal',
      letterSpacing: '-0.06em',
    },
    h2: {
      fontSize: '1.6em',
      fontWeight: 600,
      fontKerning: 'normal',
      letterSpacing: '-0.06em',
      marginTop: '1em',
    },
    h5:{
      fontWeight:600,
    },
    button: {
      fontWeight: 600,
      fontSize: '1em',
      paddingTop: '0.8em'
    },
  },
});

const ga4react = new GA4React("G-8JZHJ8PDBJ");

function App() {
  return (
      <React.Fragment> 
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <MenuPrincipal/>
          <Box id='Marjolaine' sx={{
            overflowX: 'hidden',
            paddingTop: 14,
            backgroundColor: white,
            color: black,
          }}>
            <Box sx={{ backgroundColor: white, paddingBottom: '1em' }}>
              <Container maxWidth="md">
                <Marjolaine/>
              </Container>
            </Box>
            <Box sx={{ backgroundColor: blue }}>
              <Container maxWidth="md">
                <CestQuoi/>
              </Container>
            </Box>
            <Box sx={{ backgroundColor: yellow }}>
              <Container maxWidth="md">
                <QuandConsulter/>
              </Container>
            </Box>
            <Box sx={{ backgroundColor: white }}>
              <Container maxWidth="md">
                <Tarifs/>
              </Container>
            </Box>
            <Box sx={{ backgroundColor: white }}>
              <Container maxWidth="md">
                <Coordonnees/>
              </Container>
            </Box>
            <Box sx={{ borderTop: '10px solid '+black, backgroundColor: black }}>
              <Carte/>
            </Box>
            <Box sx={{
              padding: '2em',
              backgroundColor: black,
              color: white,
              fontWeight: 600,
              //fontSize: '1rem',
              paddingBottom: '6em',
            }}>
              <Container maxWidth="md">
                <Pied/>
              </Container>
            </Box>
          </Box>
          <CookieConsent 
            enableDeclineButton 
            buttonText="J'accepte" 
            declineButtonText="Je refuse" 
            cookieName="mggraphoCookie"
            style={{ background: black }}
            buttonStyle={{ background: green }}
            declineButtonStyle={{ background: red, color: "#000000" }}
            onAccept={() => {
              ga4react.initialize().then((ga4) => {
                ga4.pageview('/')
              },(err) => {
                console.error(err);
              })
            }}
          >
            Ce site utilise des cookies à des fins de mesure d'audience.
          </CookieConsent>
        </ThemeProvider>
      </React.Fragment>
  );
}

export default App;